export default __webpack_public_path__ + "static/media/bucky.a78c5726.jpg";